import { ClassNameConsumer } from 'app/_utils/styled/ClassNameConsumer';

import { RightOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import styled from 'styled-components';

export const SelectWorkspaceModalWrapper = styled(ClassNameConsumer)`
  padding-bottom: 0px;
  width: 1100px!important;
  max-width: calc(100vw - 16px);
  height: calc(90vh - 40px)!important;
  top: 5vh!important;
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 250px);
    overflow-y: auto;
  }
  .ant-modal-content {
    border-radius: 6px;
    height: 100%;
  }
  .ant-modal-footer {
    background-color: #eff4f7;
    height: 50px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    border-radius: 0px 0px 6px 6px;
  }
  .ant-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-radius: 6px 6px 0px 0px;
    background-color: #eff4f7;
  }
  .ant-table-wrapper {
    border: 1px solid #d9d9d9;
  }
  .current-workspace-row {
    background-color: #e6f7ff;
  }
  .current-workspace-row > td {
    background-color: transparent !important;
  }
  .current-workspace-row:hover {
    background-color: #e6f7ff;
    box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.02);
  }
  .current-workspace-row:hover > td {
    background-color: transparent;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const AddWorkspaceButton = styled(Button)`
  height: 32px;
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleText = styled.span`
  font-size: 12px;
  color: rgba(0,0,0,.45);
`;

export const TitleDivider = styled(RightOutlined)`
  color: rgba(0, 0, 0, 0.45);
  margin: 5px;
  font-size: 12px;
`;

export const SelectText = styled.div`
  font-size: 15px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: bold;
`;

export const WorkspacesTableWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const WorkspaceInfo = styled.a`
  display: flex;
  cursor: pointer;
`;

export const WorkspaceInfoText = styled.div`
  display: flex;
`;

export const WorkspaceIconWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const InactiveWorkspaceInfoWrap = styled(ClassNameConsumer)`
  fill: rgba(0, 0, 0, 0.25);
  color: rgba(0, 0, 0, 0.25);
  a {
    color: rgba(0, 0, 0, 0.25);
  }
`;

export const WorkspaceInfoWrap = styled(ClassNameConsumer)`
  fill: rgba(24, 144, 255, 1);
  color: rgba(24, 144, 255, 1);
  a {
    color: rgba(24, 144, 255, 1);
  }
`;

export const WorkspaceName = styled.span`
  margin-left: 5px;
`;

export const SettingsButton = styled.button`
  width: 100%;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid #d9d9d9;
  padding: 4px 15px;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;
  transition: all .3s cubic-bezier(.645, .045, .355, 1);
  user-select: none;
  touch-action: manipulation;
  color: rgba(0, 0, 0, .85);
  border-color: #d9d9d9;
  background: transparent;

  &:hover {
    color: #40a9ff;
    border-color: #40a9ff;
    background: transparent;
  }

  &:active {
    color: #096dd9;
    border-color: #096dd9;
    background: transparent;
  }
`;

export const WorkspaceSearch = styled(Input.Search)`
  width: 40%;
  margin-bottom: 15px;
`;
